export default __webpack_public_path__ + "static/media/debaiqi-logo.80289805.svg";